// Configuration file for What's New items
// This file contains all the items that will be displayed in the What's New modal
// You can easily add, remove, or modify items by editing this array

export const whatsNewItems = [
  {
    id: 1,
    title: "Advanced Permission Management",
    description: "Streamline security governance with our comprehensive permission management system. Define granular access controls, automate permission updates, and ensure customers receive exactly the right level of access to your marketplace applications.",
    category: "New Feature",
    image: "/assets/images/whats-new/permission-management.png",
    features: [
      "Granular permission definitions",
      "Automated permission deployment",
      "Customer-specific access controls",
      "Real-time permission updates",
      "Audit trail and compliance tracking"
    ],
    date: "2025-10-16",
    actionText: "Configure Permissions",
    actionUrl: "/apps",
    external: false
  },
  {
    id: 2,
    title: "Dynamic Resource Allocation",
    description: "Optimize your container applications with intelligent resource management. Scale CPU, memory, and storage dynamically based on real-time demand, ensuring optimal performance while controlling costs.",
    category: "New Feature",
    image: "/assets/images/whats-new/resource-allocation.png",
    features: [
      "Dynamic CPU and memory scaling",
      "Demand-based resource adjustment",
      "Cost optimization algorithms",
      "Performance monitoring integration",
      "Custom scaling policies"
    ],
    date: "2025-10-16",
    actionText: "Manage Resources",
    actionUrl: "/app-instances",
    external: false
  },
  {
    id: 3,
    title: "Network Access Control",
    description: "Secure your container applications with enterprise-grade network controls. Implement IP whitelisting, create custom access policies, and ensure your applications are only accessible to authorized networks and users.",
    category: "New Feature",
    image: "/assets/images/whats-new/networking.png",
    features: [
      "IP address whitelisting",
      "Network access policies",
      "Geographic restrictions",
      "Custom firewall rules",
      "Traffic monitoring and analytics"
    ],
    date: "2025-10-16",
    actionText: "Configure Networking",
    actionUrl: "/app-instances",
    external: false
  }
];

// Helper function to get the latest items (useful for notifications or badges)
export const getLatestItems = (count = 3) => {
  return whatsNewItems
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, count);
};

// Helper function to get items by category
export const getItemsByCategory = (category) => {
  return whatsNewItems.filter(item => item.category === category);
};

// Helper function to add a new item (for admin/developer use)
export const addNewItem = (newItem) => {
  const item = {
    id: Math.max(...whatsNewItems.map(item => item.id)) + 1,
    date: new Date().toISOString().split('T')[0],
    ...newItem
  };
  whatsNewItems.unshift(item);
  return item;
};

// Helper function to remove an item
export const removeItem = (id) => {
  const index = whatsNewItems.findIndex(item => item.id === id);
  if (index > -1) {
    return whatsNewItems.splice(index, 1)[0];
  }
  return null;
};
